import { render, staticRenderFns } from "./hotList.vue?vue&type=template&id=34b15f81&scoped=true&"
import script from "./hotList.vue?vue&type=script&lang=js&"
export * from "./hotList.vue?vue&type=script&lang=js&"
import style0 from "./hotList.vue?vue&type=style&index=0&id=34b15f81&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b15f81",
  null
  
)

export default component.exports